module.exports = __webpack_public_path__ + "static/hiw-img-c5675a386963241e89dc0be4cd07fb2e.svg";